import React, { useState } from 'react'
import Header from './Header'
import ClearIcon from '../ui_icons/close.svg'
import FlashIcon from '../ui_icons/flash.svg'
import SendIcon from '../ui_icons/send.svg'
import MaximizeIcon from '../ui_icons/maximize.svg'
import { FLASH_DURATION, MAX_CHARACTER_COUNT } from '../helpers/constants'

export default function Dashboard({
  message,
  message_ref,
  flash,
  flash_ref,
  setStageView
}) {
  const [messageInputValue, setMessageInputValue] = useState('')

  function clearMessage() {
    setMessageInputValue('')
    message_ref.set('')
    flash_ref.set(false)
  }

  function flashMessage() {
    flash_ref.set(true)

    setTimeout(() => {
      flash_ref.set(false)
    }, FLASH_DURATION)
  }

  function sendMessage() {
    message_ref.set(messageInputValue)
    setMessageInputValue('')
  }

  return (
    <>
      <Header />
      <main id="dashboard">
        <section id="dashboard-message-input-panel">
          <h3>
            MESSAGE INPUT ({messageInputValue.length}/{MAX_CHARACTER_COUNT})
          </h3>

          <textarea
            type="text"
            placeholder="Your message here..."
            value={messageInputValue}
            onChange={e =>
              setMessageInputValue(
                e.target.value.substring(0, MAX_CHARACTER_COUNT)
              )
            }
          />

          <div id="control-buttons">
            <button
              onClick={sendMessage}
              id="send-button"
              disabled={!messageInputValue}
              data-mixpanel-component="send-button"
            >
              <img src={SendIcon} alt="Send message" />
              Send to stage
            </button>
          </div>
        </section>
        <section
          id="dashboard-stage-preview-panel"
          className={flash ? 'flashing' : null}
        >
          <div id="dashboard-panel-header">
            <h3>Stage View</h3>
            <button id="maximize-button" onClick={() => setStageView(true)}>
              <img src={MaximizeIcon} alt="Maximize stage view" />
            </button>
          </div>
          <div id="stage-preview">{message}</div>

          <div id="control-buttons">
            <button
              onClick={clearMessage}
              id="clear-button"
              disabled={!message}
              data-mixpanel-component="clear-button"
            >
              <img src={ClearIcon} alt="Clear message" />
              Clear
            </button>
            <button
              onClick={flashMessage}
              id="flash-button"
              disabled={flash || !message}
              data-mixpanel-component="flash-button"
            >
              <img src={FlashIcon} alt="Flash message" />
              Flash
            </button>
          </div>
        </section>
      </main>
    </>
  )
}
